import { passCodes } from '../passCodes';

const hints = [
    {
        text: 'Podívejte se i z boku domu, najdete zde nápovědu.',
    },
    {
        text: 'Jde o nejznámějšího svatého české země, svátek má 28. 9.',
    },
    {
        text: 'Kódem je: b',
        solution: true,
    },
];
export const step8house = {
    id: 8,
    title: '4. stanoviště',
    taskText: `
                <p>
                    Vždycky mě zajímalo, co je to tu za člověka, nevíš?
                </p>
            `,
    catImage: 3,
    cipher: {
        text: `
            <p>
                O jakého svatého na budově se jedná?
            </p>
            <ol type="a">
                <li>sv. Jiří</li>
                <li>sv. Václav</li>
                <li>sv. Patrik</li>
            </ol>
        `,
        label: 'Úkol',
    },
    codeInputText: 'Zadejte a/b/c',
    codeInputPassCodeRegexp: passCodes[4],
    hints: hints,
    snowHints: hints,
};
